import { useEffect, useRef } from "react";

// Runs `fn` once on mount; keeps the latest `fn` without re-running.
export function useMountEffect(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    ref.current();
  }, []);
}
